<p-panel>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-sm-12 gap-5 d-flex flex-row items-end align-items-end mb-8">
                <div>
                    <label for="">DNI/CIF: </label>
                    <input maxlength="9" class="form-control" type="text" [(ngModel)]="dni">
                    <small class="form-text text-muted text-red" *ngIf="dni && dni.length !== 9">
                        El DNI/CIF debe tener 9 caracteres
                    </small>
                </div>

                <button pButton label="Buscar" (click)="buscaDni()" class="btn align-self-end"
                    style="padding: 0.4rem; font-size: 1rem; background-color: #27A745; color:white; height: fit-content;"
                    icon="pi pi-search" [disabled]="dni.length !== 9">
                </button>

                <div *ngIf="!localizado && dni.length === 9">
                    <span>
                        <i style="font-size: 30px !important;" class="fa fa-spinner fa-spin fa-2"
                                    aria-hidden="true"></i>
                    </span>
                </div>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-12">
                <div class="bg-white rounded-4 p-5">
                    
                    <table id="data" *ngIf="showRopo" class="table table-bordered table-striped table-hover table-receta tablas">
                        <thead>
                            <tr>
                                <th>Código</th>
                                <th>Nombre</th>
                                <th>Nivel</th>
                                <th>Caducidad</th>
                                <th>Categoría</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ropo of informeROPO">
                                <td>{{ropo['código'] || ''}}</td>
                                <td>{{ropo.nombre || ''}}</td>
                                <td>{{ropo.nivel || ''}}</td>
                                <td>{{ropo.caducidad || ''}}</td>
                                <td>{{ropo['categoría'] || ''}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <br>

                    <p *ngIf="!showRegepa && this.appName !== 'avafitogest'">Sin datos de REGEPA</p>
                    <h6 *ngIf="showRegepa  && this.appName !== 'avafitogest'">Datos REGEPA</h6>

                    <table *ngIf="showRegepa && this.appName !== 'avafitogest'"
                        class="table table-bordered table-striped table-hover table-receta tablas">
                        <thead>
                            <tr>
                                <th>Código</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{this.codigo_regepa || ''}}</td>

                            </tr>
                        </tbody>
                    </table>
                    <br>

                    <p *ngIf="!showRoma">Sin datos de ROMA</p>
                    <h6 *ngIf="showRoma">Datos ROMA</h6>

                    <table *ngIf="showRoma" class="table table-bordered table-striped table-hover table-receta tablas">
                        <thead>
                            <tr>
                                <th>Código</th>
                                <th>Tipo</th>
                                <th>Marca</th>
                                <th>Modelo</th>
                                <th>Estado</th>
                                <th>Fecha inspección</th>
                                <th>Fecha caducidad</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let roma of informeROMA">
                                <td>{{roma.codigo || ''}}</td>
                                <td>{{roma.tipo || ''}}</td>
                                <td>{{roma.marca || ''}}</td>
                                <td>{{roma.modelo || ''}}</td>
                                <td>{{roma.estado || ''}}</td>
                                <td>{{roma.fecha_inspeccion || ''}}</td>
                                <td>{{roma.fecha_caducidad || ''}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-lg-12 gap-5 d-flex flex-row items-end align-items-end gap-5">
                <button pButton label="Volver" class="btn btn-dark" (click)="back()">
                </button>
                <button *ngIf="showRopo" pButton severity="info" label="Imprimir Consulta" (click)="imprimirConsulta()" [disabled]="isGeneratingCanvas"
                    class="btn">
                </button>
                <button *ngIf="showRopo" pButton severity="contrast" label="Añadir al listado" (click)="saveWorker()" class="btn btn-success"></button>
            </div>
        </div>
    </div>

</p-panel>